module.exports = __webpack_public_path__ + "static/media/TruBridge.ff5b7fb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/Home/TruBridge.png
// module id = 417
// module chunks = 0